import CONSTANTS from '../constants';

export const alerts = {
	success,
	error,
	clear
};

function success(message) {
	return { type: CONSTANTS.ALERTS.SUCCESS, message };
}

function error(message) {
	return { type: CONSTANTS.ALERTS.ERROR, message };
}

function clear() {
	return { type: CONSTANTS.ALERTS.CLEAR };
}